import { appendTickerToPolymarketLink } from "~/feature/event/utils/appendTickerToPolymarketLink";
import type { IAggregatedEvent, IMarket } from "~/types/event";

export const getPlatformTradeLink = (
  market: IMarket,
  event: IAggregatedEvent
): string =>
  appendTickerToPolymarketLink(
    event.groupedEvents?.find((item) => item.platform === market.platform)
      ?.link || "",
    market.platform,
    market.ticker
  );
